import { useCallback } from 'react';

import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { ActionIcon, Portal } from 'ui';
import { IconChevronLeft } from 'ui/Icons';

import { headerBackButtonContainerRefAtom } from './navigation.atoms';

const HeaderBackButton = ({ routeTo = '' }) => {
  const navigate = useNavigate();
  const [headerLogoContainerElement] = useAtom(headerBackButtonContainerRefAtom);

  const _navigate = useCallback(() => navigate(routeTo || '..'), [navigate, routeTo]);

  if (!headerLogoContainerElement?.current) return null;

  return (
    <Portal target={headerLogoContainerElement.current}>
      <ActionIcon
        variant="gray"
        onClick={() => {
          _navigate?.();
        }}
        // used to identify the button within the header for layout purposes
        id="header-back-button"
      >
        <IconChevronLeft />
      </ActionIcon>
    </Portal>
  );
};

const RouteWithHeaderBackButton = ({
  children,
  routeTo,
}: {
  children: React.ReactNode;
  routeTo?: string;
}) => {
  return (
    <>
      <HeaderBackButton routeTo={routeTo} />
      {children}
    </>
  );
};

export { HeaderBackButton, RouteWithHeaderBackButton };
